import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { HeaderContainer } from '../global/HeaderContainer';
import NavContainer from '../global/NavContainer';
import Destination from'../Destination';
import Switcher from './Switcher';
import FooterContainer from '../global/FooterContainer';
import '../../css/global.scss';

const destinationData = {
  id: '202206-kroger', // this id will be given to the div that wraps your destination markup.
  lander: {
    hed: 'Build a Better BBQ',
    hed2: '12 Tasty Grilling Recipes',
    metaDescription: 'From rugged mountains and crystal-clear lakes to amazing wineries, here are the best hidden gems in Michigan, whether you’re looking for a relaxing vacation or something more adventurous.',
    titleTag: 'Tasty Grilling Recipes You’ll Want to Make All Summer Long - PureWow',
    author: 'Rachel Gulmi',
    bgImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/lander-background-image-desktop.jpg',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/lander-background-image-mobile.jpg',
    },
  },
  sections: [{
    // Section 1
    type: 'meat',
    navHed: {
      desktop: '<strong style="font-size: 50px; font-weight: 700;">MEAT<span style="font-size: 40px; line-height: 40px;"> the crew</span></strong>',
      mobile: '<strong style="font-size: 50px; font-weight: 700;">MEAT</strong> <span style="font-size: 40px; font-weight: 700;"> the crew</span>',
    },
    hed: {
      desktop: '<strong style="font-size: 50px;">MEAT<span style="font-size: 40px; line-height: 40px;"> <br>the<br>crew</span></strong>',
      mobile: '<strong style="font-size: 50px;">MEAT<span style="font-size: 40px;"> the crew</span></strong>',
    },
    icon: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/icons/1-meet+the+crew.png',
    hoverImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/hovers/1-meat-the-crew-hover.jpg',
    headerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/top-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/top-design-background_mobile.png',
    },
    footerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/bottom-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/bottom-design-background_mobile.png',
    },
    nextSectionText: 'check out: veg out',
    subSections: [{
      type: 'meat',
      moduleType: 'main-recipe',
      title: 'Caramelized Onion Burger',
      subTitle: 'with Herbed Dijon and Cheese Fondue',
      videoEmbed: '<iframe src="https://player.vimeo.com/video/724602645?h=472feb4a37&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479%22?" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="iframe" width="100%" height="100%" title="KRG_Recipe 1_4x5_v10.mp4"></iframe>',
      body: 'Cheeseburgers are so last summer. This year, step up your grilling game with this one-of-a-kind burger using Bacon Cheddar Fresh Angus Beef Patties as the base. Top with homemade caramelized onions, herbed Dijon sauce and a fondue (yes, fondue!) made with Cheddar Gruyere Cheese Wedge. The best part? It’s sandwiched between a delicious Pretzel Hamburger Bun.',
      recipeButton: {
        buttonText: 'get the recipe',
        buttonUrl: 'https://www.purewow.com/recipes/caramelized-onion-burger-herbed-dijon',
      },
      shopButton: {
        buttonText: 'SHOP THE ESSENTIALS & MORE',
        buttonUrl: 'http://www.kroger.com/search?keyword=2022PSSummerGMGBurger&query=2022PSSummerGMGBurger&searchType=mktg%20attribute&monet=curated&fulfillment=all&pzn=relevance',
      },
    }, {
      type: 'meat',
      moduleType: 'shop',
      title: 'Shop Private Selection',
      items: [
        {
          label: 'Beef',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/product-1.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingBeef&query=2022PSSummerGrillingBeef&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Pork',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/product-2.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingPork&query=2022PSSummerGrillingPork&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Burgers & Hot Dogs',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/product-3.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingBurgerDogs&query=2022PSSummerGrillingBurgerDogs&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Seafood',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/product-4.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingSeafood&query=2022PSSummerGrillingSeafood&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Buns',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/product-5.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingBuns&query=2022PSSummerGrillingBuns&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
      ],
    }, {
      type: 'meat',
      moduleType: 'secondary-recipe',
      title: 'Burger Skewers',
      subTitle: 'Also Try:',
      img: {
        desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/Burger+Skewers+Image_desktop.jpg',
        mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg1/burger-skewer-image_mobile.jpg',
      },
      ingredients: [
        'Angus Ground Beef',
        'Extra Thick Cut Bacon',
        'Extra Sharp Vermont White Cheddar Wedge',
        'Living Lettuce, torn into small pieces',
        'Pickle Chips, drained',
        'Ruby Rows Tomatoes, halved',
      ],
      directions: [
        'Form tiny burger patties from the Private Selection Angus ground beef, using a small cookie scoop and a ring mold if you’d like them to be uniform.',
        'Heat a cast iron skillet over medium-high heat (on the stove or grill) and cook the patties.',
        'Slice the Private Selection Extra Thick Center Cut Bacon into thirds. In a skillet over medium heat, cook until crisp and browned.',
        'Slice the Private Selection Extra Sharp Vermont White Cheddar into squares slightly smaller than the cooked burger patties.',
        'To assemble, top each mini burger patty with a square of cheese, a piece of lettuce, a piece of bacon, a slice of pickle and half a tomato. Pierce from top to bottom with a toothpick or small skewer.',
      ],
    }],
  }, {
    // Section 2
    type: 'veg',
    navHed: {
      desktop: '<strong style="font-size: 50px; font-weight: 700;">VEG<span style="font-size: 40px; line-height: 40px;"> out</span></strong>',
      mobile: '<strong style="font-size: 50px; font-weight: 700;">VEG</strong> <span style="font-size: 40px; font-weight: 700;"> out</span>',
    },
    hed: {
      desktop: '<strong style="font-size: 50px;">VEG<span style="font-size: 40px; line-height: 40px;"> <br>out</span></strong>',
      mobile: '<strong style="font-size: 50px;">VEG<span style="font-size: 40px;"> out</span></strong>',
    },
    icon: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/icons/2-veg+out.png',
    hoverImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/hovers/2-veg-out-hover.jpg',
    headerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/top-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/top-design-background_mobile.png',
    },
    footerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/bottom-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/bottom-design-background_mobile.png',
    },
    nextSectionText: 'check out: top if off',
    subSections: [{
      type: 'veg',
      moduleType: 'main-recipe',
      title: 'Grilled Portobello Mushroom Pizzas',
      subTitle: '',
      videoEmbed: '<iframe src="https://player.vimeo.com/video/724591739?h=f7baffc34f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479%22"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="iframe" width="100%" height="100%" title="KRG_Recipe 2_4x5_v12.mp4"></iframe>',
      body: "A healthy alternative to pizza that you could eat every day of the week. Grilled portobello mushrooms are topped with <a class='veg' href='https://www.kroger.com/p/private-selection-basilico-tomato-basil-sauce/0001111086452?fulfillment=SHIP' target='_blank'> Tomato Basil Sauce</a>, <a class='veg' href='https://www.kroger.com/p/private-selection-aged-cheddar-blend-thick-cut-shredded-cheese/0001111008391?fulfillment=SHIP' target='_blank'> Aged Cheddar Blend Thick Cut Shredded Cheese Blend</a> and a flavorful mixture of oregano, red onions, fresh garlic and Mini Sweet Seedless Pepper Medley. And instead of using basic chili flakes, each one is garnished with a Chili Crisp Topping for a little crunch and spice.",
      recipeButton: {
        buttonText: 'get the recipe',
        buttonUrl: 'https://www.purewow.com/recipes/grilled-portobello-mushroom-pizzas',
      },
      shopButton: {
        buttonText: 'SHOP THE ESSENTIALS & MORE',
        buttonUrl: 'http://www.kroger.com/search?keyword=2022PSSummerGMGPortobello&query=2022PSSummerGMGPortobello&searchType=mktg%20attribute&monet=curated&fulfillment=all&pzn=relevance',
      },
    }, {
      type: 'veg',
      moduleType: 'shop',
      title: 'Shop Private Selection',
      items: [
        {
          label: 'Potatoes',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/product-1.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingPotatoes&query=2022PSSummerGrillingPotatoes&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Greens',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/product-2.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingGreens&query=2022PSSummerGrillingGreens&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Tomatoes',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/product-3.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingTomatoes&query=2022PSSummerGrillingTomatoes&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Onions, Peppers & Corn',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/product-4.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingOnions&query=2022PSSummerGrillingOnions&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
      ],
    }, {
      type: 'veg',
      moduleType: 'secondary-recipe',
      title: 'Charred Little Gem Salad',
      subTitle: 'Also Try:',
      img: {
        desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/Charred+Little+Gem+Salad+Image_desktop.jpg',
        mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg2/Charred+Little+Gem+Salad+Image_mobile.jpg',
      },
      ingredients: [
        'Little Gems, halved',
        'Lemon & Olive Oil Vinaigrette',
        'Parmesan Wedge, grated',
      ],
      directions: [
        'In a large bowl, toss together the Little Gems, Lemon & Oil Vinaigrette and Parmesan.',
      ],
    }],
  }, {
    // Section 3
    type: 'top',
    navHed: {
      desktop: '<strong style="font-size: 50px; font-weight: 700;">TOP<span style="font-size: 40px; line-height: 40px;"> it off</span></strong>',
      mobile: '<strong style="font-size: 50px; font-weight: 700;">TOP</strong> <span style="font-size: 40px; font-weight: 700;"> it off</span>',
    },
    hed: {
      desktop: '<strong style="font-size: 50px;">TOP<span style="font-size: 40px; line-height: 40px;"> <br>it<br>off</span></strong>',
      mobile: '<strong style="font-size: 50px;">TOP<span style="font-size: 40px;"> it off</span></strong>',
    },
    icon: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/icons/3-top+it+off.png',
    hoverImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/hovers/3-top-it-off-hover.jpg',
    headerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/top-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/top-design-background_mobile.png',
    },
    footerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/bottom-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/bottom-design-background_mobile.png',
    },
    nextSectionText: 'check out: ride or side',
    subSections: [{
      type: 'top',
      moduleType: 'main-recipe',
      title: 'Barbecue Brisket',
      subTitle: 'with Private Selection Blackstrap Molasses BBQ Sauce',
      videoEmbed: '<iframe src="https://player.vimeo.com/video/724577555?h=301b38edcd&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479%22"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="iframe" width="100%" height="100%" title="220622_Kroger_Brisket_1x1_draft04.mp4"></iframe>',
      body: "When you purchase a good cut of meat, it doesn’t need all the bells and whistles—just a simple rub and if you’re going for BBQ—a good sauce. In this case, Beef Brisket is basted with <a class='top' href='https://www.kroger.com/p/private-selection-blackstrap-molasses-bbq-sauce/0001111010323?fulfillment=SHIP' target='_blank'> Blackstrap Molasses BBQ Sauce</a> that gets caramelized on the grill. Yum.",
      recipeButton: {
        buttonText: 'get the recipe',
        buttonUrl: 'https://www.purewow.com/recipes/barbecue-brisket',
      },
      shopButton: {
        buttonText: 'SHOP THE ESSENTIALS & MORE',
        buttonUrl: 'http://www.kroger.com/search?keyword=2022PSSummerGMGBrisket&query=2022PSSummerGMGBrisket&searchType=mktg%20attribute&monet=curated&fulfillment=all&pzn=relevance',
      },
    }, {
      type: 'top',
      moduleType: 'shop',
      title: 'Shop Private Selection',
      items: [
        {
          label: 'Cheese',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/product-1.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingCheese&query=2022PSSummerGrillingCheese&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Rubs',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/product-2.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingRubs&query=2022PSSummerGrillingRubs&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'BBQ Sauce',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/product-3.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingBBQSauce&query=2022PSSummerGrillingBBQSauce&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Toppers',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/product-4.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingSauces&query=2022PSSummerGrillingSauces&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Wing Sauce',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/product-5.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingWingSauce&query=2022PSSummerGrillingWingSauce&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Marinades',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/product-6.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingMarinades&query=2022PSSummerGrillingMarinades&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
      ],
    }, {
      type: 'top',
      moduleType: 'secondary-recipe',
      title: 'Hot Dog Grilled Cheese',
      subTitle: 'Also Try:',
      img: {
        desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/Hot+Dog+Grilled+Cheese+Image_desktop.jpg',
        mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/Hot+Dog+Grilled+Cheese+Image_mobile.jpg',
      },
      ingredients: [
        'Brioche Hot Dog Buns',
        'French Salted Butter, at room temperature',
        'Premium All-Beef Hot Dogs, butterflied',
        'Extra Sharp Vermont White Cheddar, sliced',
        'Zesty Garlic Hungarian Sliced Wax Peppers',
        'Honey Maple BBQ Sauce',
      ],
      directions: [
        'Gently flatten the hot dog buns with a rolling pin and spread the butter evenly on the outsides of the buns.',
        'In a large skillet over medium heat, sear the hot dogs until browned. Set aside.',
        'Working in batches as needed, place the open buns buttered side down in the skillet and top with cheese, a hot dog and a little more cheese. Cook over medium heat until the cheese melts and the buns are toasted, then use a spatula to close the bun. Top with the peppers and drizzle with BBQ sauce.',
      ],
    }],
  }, {
    // Section 4
    type: 'side',
    navHed: {
      desktop: '<strong style="font-size: 40px; font-weight: 700;">Ride or<span style="font-size: 50px; line-height: 40px; font-weight: 700;"> SIDE</span></strong>',
      mobile: '<strong style="font-size: 40px; font-weight: 700;">Ride or</strong> <span style="font-size: 50px; font-weight: 700;"> SIDE</span>',
    },
    hed: {
      desktop: '<strong>Ride<br>or<br><span style="font-size: 50px;">SIDE</span></strong>',
      mobile: '<strong style="font-size: 40px;">Ride or <span style="font-size: 50px;">SIDE</span></strong>',
    },
    icon: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/icons/4-ride+or+side.png',
    hoverImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/hovers/4-ride-or-side-image.jpg',
    headerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/top-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/top-design-background_mobile.png',
    },
    footerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/bottom-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/bottom-design-background_mobile.png',
    },
    nextSectionText: 'check out: treat yourself, you dessert it',
    subSections: [{
      type: 'side',
      moduleType: 'main-recipe',
      title: 'Bacon-Wrapped Shrimp, Peach and Tomatoes',
      subTitle: 'with Honey Lemon Glaze',
      videoEmbed: '<iframe src="https://player.vimeo.com/video/724598803?h=389ad908b9&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479%22"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="iframe" width="100%" height="100%" title="KRG_Recipe 4_4x5_v13.mp4"></iframe>',
      body: "Bacon-wrapped anything will get our attention, but these three appetizer options are our favorite go-tos. Take your pick from Extra-Large Argentinian Shrimp, Donut Peaches and Cherry Snacking Tomatoes. They’re each wrapped in <a class='side' href='https://www.kroger.com/p/private-selection-extra-thick-center-cut-bacon/0001111020779?fulfillment=SHIP' target='_blank'> Extra Thick Cut Bacon</a>, grilled and glazed with a homemade honey lemon sauce.",
      recipeButton: {
        buttonText: 'get the recipe',
        buttonUrl: 'https://www.purewow.com/recipes/bacon-wrapped-shrimp-peach-tomatoes',
      },
      shopButton: {
        buttonText: 'SHOP THE ESSENTIALS & MORE',
        buttonUrl: 'http://www.kroger.com/search?keyword=2022PSSummerGMGBacon&query=2022PSSummerGMGBacon&searchType=mktg%20attribute&monet=curated&fulfillment=all&pzn=relevance',
      },
    }, {
      type: 'side',
      moduleType: 'shop',
      title: 'Shop Private Selection',
      items: [
        {
          label: 'Chips',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/product-1.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingChips&query=2022PSSummerGrillingChips&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Dips',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/product-2.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingDips&query=2022PSSummerGrillingDips&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Pasta',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/product-3.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingPasta&query=2022PSSummerGrillingPasta&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Crackers',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/product-4.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingCrackers&query=2022PSSummerGrillingCrackers&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Nuts',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg4/product-5.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingNuts&query=2022PSSummerGrillingNuts&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
      ],
    }, {
      type: 'side',
      moduleType: 'secondary-recipe',
      title: 'Wild Violet Gnocchi Skillet',
      subTitle: 'Also Try:',
      img: {
        desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/Hot+Dog+Grilled+Cheese+Image_desktop.jpg',
        mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg3/Hot+Dog+Grilled+Cheese+Image_mobile.jpg',
      },
      ingredients: [
        '4 ears Wild Violet Corn',
        '1 pound Basil Pesto Gnocchi',
        '3 cups Ruby and Golden Rows Tomatoes',
        '1 red onion, sliced',
        '3 tablespoons Garlic Infused Olive Oil, divided',
        'Kosher salt and freshly ground black pepper',
        '4 ounces arugula',
        '8 ounces Fresh Mozzarella',
      ],
      directions: [
        'Preheat the grill for high heat and set a cast iron pan on one side of the grates.',
        'Grill the corn until charred and tender, 5 to 7 minutes. Cut the kernels off the cobs and set aside.',
        'Bring a large pot of salted water to a boil. Add the gnocchi and cook until they float to the surface, about 5 minutes; drain.',
        'In a medium bowl, toss the tomatoes and red onion with half of the olive oil and season with salt and pepper.',
        'Add remaining oil to pan. Sauté the tomatoes and onion until charred and blistered, about 4 minutes. Add the corn and gnocchi; toss together over medium heat for about 2 minutes more. Add the arugula and cook until wilted.',
        'Remove the skillet from the heat and toss with the fresh mozzarella.',
      ],
    }],
  }, {
    // Section 5
    type: 'dessert',
    navHed: {
      desktop: '<strong style="font-size: 40px; font-weight: 700;">Treat yourself, you <span style="font-size: 50px; line-height: 40px; font-weight: 700;"> DESSERT</span><span style="font-size: 40px; font-weight: 700;"> it!</span></strong>',
      mobile: '<span style="font-size: 40px; font-weight: 700;">treat yourself,<br> you</span> <strong style="font-size: 50px; font-weight: 700;">DESSERT</strong> <span style="font-size: 40px; font-weight: 700;">it!</span>',
    },
    hed: {
      desktop: '<strong>treat<br>yourself,<br>you<br><span style="font-size: 50px;">DESSERT</span><br>it!</strong>',
      mobile: '<strong style="font-size: 40px; font-weight: 700;">treat yourself,<br>you <span style="font-size: 50px;">DESSERT</span><span style="font-size: 40px; font-weight: 700;"> it!</span></strong>',
    },
    icon: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/icons/5-you+dessert+it.png',
    hoverImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/hovers/5-you-dessert-it-hover.jpg',
    headerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/top-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/top-design-background_mobile.png',
    },
    footerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/bottom-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/bottom-design-background_mobile.png',
    },
    nextSectionText: 'check out: drink in the summer',
    subSections: [{
      type: 'dessert',
      moduleType: 'main-recipe',
      title: 'Macaron Tower',
      subTitle: 'with Honey Lemon Glaze',
      videoEmbed: '<iframe src="https://player.vimeo.com/video/724592931?h=3e4cbc443f&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479%22"  frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="iframe" width="100%" height="100%" title="220614_Kroger_MacaronTower_1x1_draft11.mp4"></iframe>',
      body: "Cupcake tree? Been there. Donut wall? Done that. At your next outdoor soiree, put together a macaron tower. Not only is it photo-worthy (a rainbow of color), it’s beyond easy to put together. All you need is a dessert tower, <a class='dessert' href='https://www.kroger.com/p/private-selection-assorted-macarons/0001111009788?fulfillment=SHIP&searchType=default_search' target='_blank'> Assorted Macarons</a> and <a class='dessert' href='https://www.kroger.com/p/private-selection-extra-creamy-whipped-heavy-cream/0001111001790?fulfillment=SHIP&searchType=default_search' target='_blank'> Extra Creamy Whipped Heavy Cream</a>. Arrange the treats around each section and add a dollop of whipped cream between each. Yes, it’s that easy.",
      recipeButton: {
        buttonText: 'get the recipe',
        buttonUrl: 'https://www.purewow.com/recipes/macaron-tower',
      },
      shopButton: {
        buttonText: 'SHOP THE ESSENTIALS & MORE',
        buttonUrl: 'http://www.kroger.com/search?keyword=2022PSSummerGMGMacaron&query=2022PSSummerGMGMacaron&searchType=mktg%20attribute&monet=curated&fulfillment=all&pzn=relevance',
      },
    }, {
      type: 'dessert',
      moduleType: 'shop',
      title: 'Shop Private Selection',
      items: [
        {
          label: 'Ice Cream',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/product-1.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingIceCream&query=2022PSSummerGrillingIceCream&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Pies',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/product-2.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingPies&query=2022PSSummerGrillingPies&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Cookies, Bars & Chocolate',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/product-3.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingCookiesChocolate&query=2022PSSummerGrillingCookiesChocolate&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Fruit',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/product-4.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingFruit&query=2022PSSummerGrillingFruit&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Frozen Desserts',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/product-5.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingFrozenDesserts&query=2022PSSummerGrillingFrozenDesserts&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
      ],
    }, {
      type: 'dessert',
      moduleType: 'secondary-recipe',
      title: 'Berry Parfait',
      subTitle: 'Also Try:',
      img: {
        desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/Berry+Parfait+Image_desktop.jpg',
        mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg5/Berry+Parfait+Image_mobile.jpg',
      },
      ingredients: [
        'Colossal Blueberries',
        'Super Sweet Strawberries',
        'Blackberries',
        'Madeleines',
        'Heavy Whipping Cream',
      ],
      directions: [
        'In a cup or small bowl, layer the Colossal Blueberries, Super Sweet Strawberries, blackberries and Madeleines. Top with Heavy Whipped Cream.',
      ],
    }],
  }, {
    // Section 6
    type: 'drink',
    navHed: {
      desktop: '<strong style="font-size: 50px; font-weight: 700;">DRINK<span style="font-size: 40px; line-height: 40px; font-weight: 700;"> in the summer</span></strong>',
      mobile: '<span style="font-size: 50px; font-weight: 700;">DRINK</span> <span style="font-size: 40px; font-weight: 700;">in <br> the summer</span>',
    },
    hed: {
      desktop: '<strong style="font-size: 50px;">DRINK<span style="font-size: 40px; line-height: 40px;"> in<br>the<br>summer</span></strong>',
      mobile: '<strong style="font-size: 50px;">DRINK<span style="font-size: 40px;"> in<br>the summer</span></strong>',
    },
    icon: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/icons/6-drink+in+the+summer.png',
    hoverImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/lander/hovers/6-drink-in-the-summer-image.jpg',
    headerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/top-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/top-design-background_mobile.png',
    },
    footerImage: {
      desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/bottom-design-background_desktop.png',
      mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/bottom-design-background_mobile.png',
    },
    nextSectionText: 'check out: meat the crew',
    subSections: [{
      type: 'drink',
      moduleType: 'main-recipe',
      title: 'Non-Alcoholic Chocolate Cherry Martini',
      subTitle: '',
      videoEmbed: '<iframe src="https://player.vimeo.com/video/724594793?h=fb5696ca50&amp;badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479%22" frameborder="0" allow="autoplay; fullscreen; picture-in-picture" allowfullscreen class="iframe" width="100%" height="100%" title="220614_Kroger_ChocolateCherryMartini_1x1_draft13.mp4"></iframe>',
      body: 'Every delicious meal should always be accompanied by an equally delicious drink. For this non-alcoholic martini, blend together Skylar Rae Cherries, grenadine and crème de cacao flavored syrup. Add heavy cream and shake, shake, shake. Dip the rims of each glass in Turinbado Sugar, drizzle Dark Chocolate and garnish with cherries. Hint: To turn this into a cocktail, add two ounces of cherry vodka to each martini.',
      recipeButton: {
        buttonText: 'get the recipe',
        buttonUrl: 'https://www.purewow.com/recipes/non-alcoholic-chocolate-cherry-martini',
      },
      shopButton: {
        buttonText: 'SHOP THE ESSENTIALS & MORE',
        buttonUrl: 'http://www.kroger.com/search?keyword=2022PSSummerGMGMartini&query=2022PSSummerGMGMartini&searchType=mktg%20attribute&monet=curated&fulfillment=all&pzn=relevance',
      },
    }, {
      type: 'drink',
      moduleType: 'shop',
      title: 'Shop Private Selection',
      items: [
        {
          label: 'Tea',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/product-1.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingTea&query=2022PSSummerGrillingTea&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Coffee',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/product-2.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingCoffee&query=2022PSSummerGrillingCoffee&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Mixers',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/product-3.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingMixers&query=2022PSSummerGrillingMixers&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
        {
          label: 'Indulgent Drinks',
          itemImg: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/product-4.png',
          link: 'http://www.kroger.com/search?keyword=2022PSSummerGrillingIndulgent&query=2022PSSummerGrillingIndulgent&searchType=mktg%20attribute&monet=FALSE&fulfillment=all&pzn=relevance',
        },
      ],
    }, {
      type: 'drink',
      moduleType: 'secondary-recipe',
      title: 'Strawberry Gin Cocktail',
      subTitle: 'Also Try:',
      img: {
        desktop: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/Strawberry+Gin+Cocktail+Image_desktop.jpg',
        mobile: 'https://gmg-static-assets.s3.amazonaws.com/minisite-assets/kroger/recipe_pg6/Strawberry+Gin+Cocktail+Image_mobile.jpg',
      },
      ingredients: [
        '2 large Supremely Sweet Strawberries',
        '1 ounce freshly squeezed PRSL Meyer Lemon juice',
        '½ teaspoon Turbinado Cane Sugar',
        '½ teaspoon Lemon Extract',
        '2 ounces gin',
        'Club Soda, to top',
      ],
      directions: [
        'In a cocktail shaker, muddle the Supremely Sweet Strawberries, Meyer Lemon juice and Turbinado Cane Sugar. Add the Pure Lemon Extract, gin and ice; shake until very cold.',
        'Pour into a highball glass with fresh ice and top with club soda. For a mocktail, skip the spirits.',
      ],
    }],
  },

],
};

class AppView extends Component {
  constructor() {
    super();
    this.state = {

    };
  }

  componentDidMount() {
    const { dispatch } = this.props;

    // For SSR, isMobile is always true. For client render, isMobile's value is determined by the result of the dispatch below.
    if (typeof window !== 'undefined') {
      window.addEventListener('resize', () => {
        dispatch({
          type: 'MOBILE_DETERMINE',
        });
      });

      dispatch({
        type: 'MOBILE_DETERMINE',
      });
    }
  }

  render() {
    const { isClient, isMobile } = this.props;

    /*
      To prevent flashes on desktop (i.e. because the mobile layout will render first), we can apply an opacity of 0 in cases where isClient is false
      (i.e. for the SSR). The server-rendered markup is set to the client where, on componentDidMount(), we dispatch an action that updates both
      isMobile (window.innerWidth <= 991) and isClient (true). Now that isClient is true, the div wrapping the App children below will have opacity 1.
    */
    return (
      <Fragment>
      <div className="app" style={{ opacity: isClient ? 1 : 0 }}>
        <HeaderContainer />
        <NavContainer />
        <div className="content">
          { isClient &&
            <Destination {...destinationData} isMobile={isMobile}/>
          }
          <Switcher />
        </div>
      </div>
      </Fragment>
    );
  }
}

const mapStateToProps = ({ isClient, isMobile }) => ({
  isClient,
  isMobile,
});

const mapDispatchToProps = dispatch => ({
  dispatch,
});

const App = connect(mapStateToProps, mapDispatchToProps)(AppView);

export default App;
